<template>
  <!-- -->
  <div class="home-top">
    <div class="left">
      <image-show v-model="userInfo.rootMerchant.merchantLogo" class="top-logo" width="auto" height="100%" :show-view="false"/>
<!--      <image v-if="userInfo.rootMerchant.merchantLogo" :src="userInfo.rootMerchant.merchantLogo" class="top-logo"/>-->
<!--      <img alt="" class="top-logo" :src="userInfo.rootMerchant.merchantLogo || 'https://file.yqgj.ltd/common/logo_road.png'"/>-->
<!--      <div class="top-name">{{ userInfo.rootMerchant.merchantName || '易企管家' }}</div>-->
      <div class="my-name">{{ userInfo.merchantName }}</div>
    </div>
    <div class="right">
      <div class="item notice-list">
        <message-scroll>
          <div class="notice-wrapper" v-for="(notice) in notices" :key="notice.id" @click="openNoticeDialog(notice)">
            {{ stripHtmlTags(notice.title) }}
          </div>
        </message-scroll>
      </div>

      <table-button class="item" @click="router.push(`/monitor`)">数据中台</table-button>
      <table-button class="item" @click="showChangePassword = true">修改密码</table-button>
      <table-button class="item" el-type="danger" @click="userEvent('logout')">退出登录</table-button>
      <div class="tips-message item" @click="toggleMessageList">
        <yq-icon name="element-ui_message"/>
        <div class="message-count" v-if="unreadCount > 0">{{ unreadCount > 99 ? '99+' : unreadCount }}</div>
      </div>
<!--      <message-component/>-->
<!--      <img class="item avatar" alt="" :src="userInfo.iconUrl" v-if="userInfo.iconUrl"/>-->
      <img class="item avatar" alt="" :src="getAvatar(userInfo.iconUrl)" v-if="userInfo.iconUrl"/>
      <yq-icon v-else class="item avatar" name="element-ui_s-custom"/>
      <div class="item user-name">{{ userInfo.userName }}</div>
      <div class="item role-name">{{ userInfo.roleName }}</div>
      <el-dropdown class="item" style="vertical-align: middle;line-height: 46px" trigger="click" @command="userEvent">
        <template #default>
          <yq-icon name="24gf-gear" class="setting-icon"/>
        </template>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="userInfo">
              <yq-icon name="element-ui_user"/>
              {{ $t("message.userInfo") }} <!-- 个人信息 -->
            </el-dropdown-item>
            <el-dropdown-item command="switchRole">
              <yq-icon name="element-ui_user"/>
              <!--              切换角色-->{{ $t("message.changeRole") }}
            </el-dropdown-item>
            <el-dropdown-item command="toFindVersion">
              <yq-icon name="element-ui_odometer"/>
              <!--              查看版本-->{{ $t("message.viewVersion") }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>

    <el-dialog title="修改密码" v-model="showChangePassword" width="40%">
      <el-form label-width="80px">
        <el-form-item label="旧密码">
          <el-input type="password" v-model="passwordInfo.oldPassword" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input type="password" v-model="passwordInfo.newPassword" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input type="password" v-model="passwordInfo.confirmPassword" show-password></el-input>
        </el-form-item>
        <template #footer>
          <page-button @click="showChangePassword = false">取消</page-button>
          <page-button message="修改密码后，需要重新登录，您确认操作吗？" el-type="primary" @click="changePassword">确定</page-button>
        </template>
      </el-form>
    </el-dialog>

    <!-- 使用消息列表组件 -->
    <message-list
        :visible="showMessageList"
        @close="showMessageList = false"
        @read-message="readMessage"
        @update-count="loadUnreadCount"
    />

    <!-- 公告详情对话框（点击轮播项弹出） -->
    <el-dialog
      v-model="showNoticeDialog"
      :title="currentNotice.title"
      width="600px"
      class="message-detail-dialog"
      :close-on-click-modal="false"
    >
      <div class="message-detail-wrapper">
        <div class="detail-header-info">
          <span class="message-type-tag tag-notice">系统公告</span>
          <span
            class="message-level-tag"
            v-if="currentNotice.level && currentNotice.level !== '1'"
            :class="'level-' + currentNotice.level"
          >
            {{ currentNotice.level === '2' ? '重要' : (currentNotice.level === '3' ? '紧急' : '') }}
          </span>
        </div>

        <div class="detail-content-wrapper">
          <div class="rich-content" v-html="currentNotice.content"></div>
        </div>
      </div>
      <template #footer>
        <page-button @click="showNoticeDialog = false">关闭</page-button>
      </template>
    </el-dialog>

    <el-dialog v-model="showSwitchRole" title="切换角色" width="40%">
      <el-form label-width="70px">
        <el-form-item label="职员名称">{{ editUser.employeeName || editUser.userName }}</el-form-item>
        <el-form-item label="当前机构">{{ editUser.merchantName }}</el-form-item>
        <el-form-item label="当前角色">
          <el-select v-model="editUser.roleId">
            <el-option v-for="r in editUser.roleList" :value="r.id" :label="r.roleName">
              <span class="role-info">{{ r.roleName }}</span>
              <span class="role-merchant">{{ r.merchantName }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <page-button @click="showSwitchRole = false">取消</page-button>
        <page-button el-type="primary" @click="switchRole">确认</page-button>
      </div>
    </el-dialog>

    <!-- 查看版本 -->
    <el-dialog
      v-model="showVersionDialog"
      title="版本信息"
      width="520px"
      :close-on-click-modal="false"
    >
      <div class="version-wrapper">
        <div class="version-row">
          <span class="label">应用名称</span>
          <span class="value">{{ versionInfo.appName }}</span>
        </div>
        <div class="version-row">
          <span class="label">前端版本</span>
          <span class="value">{{ versionInfo.frontVersion }}</span>
        </div>
        <div class="version-row" v-if="versionInfo.env">
          <span class="label">运行环境</span>
          <span class="value">{{ versionInfo.env }}</span>
        </div>
        <div class="version-row" v-if="versionInfo.baseApi">
          <span class="label">接口地址</span>
          <span class="value">{{ versionInfo.baseApi }}</span>
        </div>
        <div class="version-row">
          <span class="label">构建时间</span>
          <span class="value">{{ versionInfo.buildTime }}</span>
        </div>
        <div class="version-row">
          <span class="label">当前用户</span>
          <span class="value">{{ userInfo.userName }}（{{ userInfo.roleName }}）</span>
        </div>
        <div class="version-row">
          <span class="label">浏览器</span>
          <span class="value ua">{{ versionInfo.ua }}</span>
        </div>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <page-button @click="copyVersion">复制</page-button>
          <page-button el-type="primary" @click="showVersionDialog = false">关闭</page-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>

import YqIcon from "@/components/YqIcon.vue";
import util from "@/util/util";
import TableButton from "@/components/h5/button/TableButton.vue";
import MessageScroll from "@/views/h5/luqiao/home/MessageScroll.vue";
import MessageList from "@/components/h5/data/MessageList.vue";
import commonApi from "@/api/commonApi";
import noticeApi from "@/api/dz-luqiao/noticeApi";
import messageApi from "@/api/dz-luqiao/messageApi";
import ImageShow from "@/components/h5/image/ImageShow.vue";
import {useRoute, useRouter} from "vue-router";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "HomeTop",
  components: {
    TableButton, YqIcon, MessageScroll, MessageList, ImageShow,
  },
  data() {
    return {
      showChangePassword:false,
      userInfo: {
        rootMerchant: {}
      },
      currentNoticeIndex: 0,
      notices: [], // 系统公告列表，从后端获取
      messageSession: null, // 消息会话，用于和后端建立ws连接
      sessionInterval: null,
      showMessageList: false, // 是否显示消息列表
      unreadCount: 0, // 未读消息数量
      passwordInfo: {},
      // 公告弹窗
      showNoticeDialog: false,
      currentNotice: { id: '', title: '', content: '', level: '1', isRead: 'N' },
      showSwitchRole: false,
      editUser: {},
      // 版本信息
      showVersionDialog: false,
      versionInfo: {
        appName: '',
        frontVersion: '',
        env: '',
        baseApi: '',
        buildTime: '',
        ua: ''
      },
      loadingMessage: false,
    };
  },
  created() {
    util.getUserInfo().then(user => {
      if (!user.rootMerchant) {
        user.rootMerchant = {};
      }
      this.userInfo = user;
      this.createWebSocket();
      // 设置浏览器的名称
      document.title = user.rootMerchant.merchantName || user.merchantName;
    });
    // 加载系统公告
    this.loadNotices();
    // 加载未读消息数量
    this.loadUnreadCount();
  },
  unmounted() {
    if (this.messageSession) {
      this.messageSession.close();
    }
    if (this.sessionInterval) {
      clearInterval(this.sessionInterval);
    }
  },
  methods: {
    getAvatar(avatar){
      if(avatar.startsWith('http')){
        return avatar;
      }
      if(avatar.startsWith("[")){
        const data = JSON.parse(avatar);
        return process.env.VUE_APP_FILE_URL + data[0].url
      }
      return process.env.VUE_APP_FILE_URL + avatar;
    },
    async changePassword() {
      if (this.passwordInfo.newPassword.length < 6) {
        this.$message.error('密码长度不能少于6位');
        return;
      }
      await commonApi.changePasswordV2(this.passwordInfo);
      this.$message.success("修改密码成功，请重新登录！");
      commonApi.logout().then(() => {
        // 停止全局计时器
        if (this.$root.heartbeatTimer) {
          clearInterval(this.$root.heartbeatTimer)
          console.log("心跳包已停止发送...")
        }
        setTimeout(() => {
          this.$router.push("/login");
        }, 1000);
      });
    },
    createWebSocket() {
      let openSwitch = process.env.VUE_APP_MESSAGE_WS_SWITCH;
      if (openSwitch !== 'true') { // 不开启消息推送
        return;
      }
      this.messageSession = new WebSocket(process.env.VUE_APP_WS_URL + "/basedata/ws/message");
      this.messageSession.onopen = this.wsOpen;
      this.messageSession.onmessage = this.wsMessage;
      this.messageSession.onerror = this.wsError;
      this.messageSession.onclose = this.wsClose;
      if (this.sessionInterval) {
        clearInterval(this.sessionInterval);
      }
      this.sessionInterval = setInterval(() => this.heartbeat(), 30000);
    },

    // 心跳包发送
    heartbeat() {
      if (this.messageSession) {
        let cmd = {cmd: "ping"}
        this.wsSend(JSON.stringify(cmd));
      }
    },

    wsOpen() {
      console.log("远程连接已建立，开始申报用户信息")
      let json = {
        cmd: "declare",
        userId: this.userInfo.id,
      }
      this.wsSend(JSON.stringify(json));
    },

    wsSend(message) {
      if (!this.messageSession || this.messageSession.readyState === 2 || this.messageSession.readyState === 3) {
        // 重新连接
        this.createWebSocket();
        return;
      }
      this.messageSession.send(message);
    },

    wsMessage(e) {
      let data = e.data;
      if (!data.startsWith("{")) {
        console.log("服务器返回未知消息");
        console.log(data);
        return;
      }
      let json = JSON.parse(data);
      switch (json.cmd) {
        case "newMessage":
          if (json.data === "SYSTEM_WARN_MSG") {
            this.$message.info("您有新的消息，请注意查收");
            this.loadUnreadCount();
          }
          break;
        case "pong":
          console.log("服务器返回心跳包")
          break;
      }
    },

    wsError(e) {
      console.log("远程连接已断开", e)
    },

    wsClose(e) {
      console.log("远程连接已断开", e)
    },
    toSwitchRole(){
      // 切换角色
      let roleList = [...this.userInfo.roleList];
      for (let i = 0; i < roleList.length; i++) {
        for (let j = 0; j < this.userInfo.merchantList.length; j++) {
          if (roleList[i].merchantId === this.userInfo.merchantList[j].id) {
            roleList[i].merchantName = this.userInfo.merchantList[j].merchantName;
            break
          }
        }
      }
      this.editUser = {
        ...this.userInfo,
        password: "",
        roleList: roleList
      };
      this.showSwitchRole = true;
    },
    // 切换角色
    switchRole() {
      if (this.editUser.roleId === this.userInfo.roleId) {
        // 角色错误
        this.$message.error({message: "选择的角色无效"})
        return;
      }
      commonApi.switchRole(this.editUser.roleId).then((user) => {
        // 缓存登录信息
        util.setUserInfo(user);
        this.userInfo = user;
        // 清空缓存
        util.clearCacheData();
        this.showSwitchRole = false;
        this.$message.success("切换角色成功！");
        // 刷新页面
        setTimeout(() => {
          window.location.reload();
        }, 300)
      });
    },
    // 用户事件
    userEvent(command) {
      switch (command) {
        case 'userInfo': // 个人信息
          this.router.push("/sys/user/info");
          break;
        case 'switchRole':
          this.toSwitchRole()
          break;
        case 'toFindVersion':
          this.openVersionDialog();
          break;
        case 'logout': // 退出登录
          commonApi.logout().then(() => {
            // 停止全局计时器
            if (this.$root.heartbeatTimer) {
              clearInterval(this.$root.heartbeatTimer)
              console.log("心跳包已停止发送...")
            }
            this.router.push("/login");
          });
          break;
      }
    },
    // 打开版本信息
    openVersionDialog() {
      const pad = (n) => (n < 10 ? '0' + n : n);
      const d = new Date();
      const build = `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
      this.versionInfo = {
        appName: process.env.npm_package_name || '前端应用',
        frontVersion: process.env.npm_package_version || '0.0.0',
        env: process.env.NODE_ENV,
        baseApi: process.env.VUE_APP_BASE_API || '',
        buildTime: build,
        ua: navigator.userAgent
      };
      this.showVersionDialog = true;
    },
    // 复制版本信息
    async copyVersion() {
      const v = this.versionInfo;
      const text = `应用名称: ${v.appName}\n前端版本: ${v.frontVersion}\n运行环境: ${v.env}\n接口地址: ${v.baseApi}\n构建时间: ${v.buildTime}\n浏览器: ${v.ua}`;
      try {
        await navigator.clipboard.writeText(text);
        this.$message.success('版本信息已复制');
      } catch (e) {
        this.$message.error('复制失败');
      }
    },

    // 加载系统公告
    async loadNotices() {
      try {
        // 调用新接口，获取当前用户有权限阅读的公告（最多5条）
        const res = await noticeApi.getMyNotices(5);

        if (res && res.length > 0) {
          // 格式化公告数据用于滚动显示
          this.notices = res.map(notice => ({
            id: notice.id,
            title: notice.title,
            content: notice.content || notice.title,
            time: notice.publishTime,
            level: notice.level, // 重要级别
            isTop: notice.isTop, // 是否置顶
            isRead: notice.isRead || 'N' // 是否已读
          }));
        } else {
          this.notices = [];
        }
      } catch (error) {
        // 失败时显示空列表，不影响页面其他功能
        this.notices = [];
      }
    },
    readMessage(count) {
      this.unreadCount = this.unreadCount - count;
    },
    // 加载未读消息数量（页面加载时调用）
    async loadUnreadCount() {
      try {
        if (this.loadingMessage) {
          // 重复请求，返回
          return;
        }
        this.loadingMessage = true;
        // 并行获取系统公告和系统预警
        const data = await messageApi.myWarnMessageList({status: 0});
        this.unreadCount = data.totalCount;
        this.loadingMessage = false;// 加载标记，返回
      } catch (error) {
        console.error('加载未读消息数量失败:', error);
        this.unreadCount = 0;
      }
    },

    // 切换消息列表显示
    toggleMessageList() {
      this.showMessageList = !this.showMessageList;
    },

    // 打开公告详情弹窗
    async openNoticeDialog(notice) {
      if (!notice) return;
      
      // 与消息列表一致：支持富文本
      this.currentNotice = {
        id: notice.id,
        title: notice.title || '公告详情',
        content: notice.content || '',
        level: notice.level || '1',
        isRead: notice.isRead || 'N'
      };
      this.showNoticeDialog = true;
      
      // 如果公告未读，立即标记为已读
      if (notice.isRead === 'N') {
        await this.markNoticeAsRead(notice);
      }
    },
    
    // 标记公告为已读
    async markNoticeAsRead(notice) {
      // 如果已经是已读状态，直接返回
      if (notice.isRead === 'Y') {
        return;
      }
      
      try {
        // 调用公告已读接口
        await noticeApi.recordRead(notice.id, this.userInfo.id, 'PC');
        
        // 更新本地状态
        notice.isRead = 'Y';
        this.currentNotice.isRead = 'Y';
        
        // 更新未读消息数量
        await this.loadUnreadCount();
        
        console.log('✓ 公告已成功标记为已读');
      } catch (error) {
        console.error('❌ 标记已读失败:', error);
        // 标记失败时不更新本地状态
      }
    },

    // 保留 stripHtmlTags 方法用于公告滚动显示
    stripHtmlTags(html) {
      if (!html) return '';
      try {
        // 先处理转义的引号
        let decodedHtml = html.replace(/\\"/g, '"').replace(/\\'/g, "'");
        // 创建一个临时div元素
        const tmp = document.createElement('div');
        tmp.innerHTML = decodedHtml;
        // 获取纯文本内容
        let text = tmp.textContent || tmp.innerText || '';
        // 去除多余的空白字符和换行
        text = text.replace(/\s+/g, ' ').trim();
        return text;
      } catch (error) {
        console.error('解析HTML失败:', error);
        return '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.version-wrapper {
  .version-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 0;

    .label {
      width: 90px;
      color: #606266;
      flex-shrink: 0;
    }
    .value {
      color: #303133;
      word-break: break-all;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .ua {
      -webkit-line-clamp: 3;
      line-clamp: 3;
    }
  }
}
.home-top {
  height: 50px;
  display: flex;
  justify-content: space-between;
  --desc-font-color: #999;
  //background: linear-gradient(45deg, #5aabfd,#409eff);
  background: #FFF;
  color: #000;
  overflow: hidden;
  border-bottom: 2px solid var(--yq-border-color);

  .left {
    display: inline-flex;
    line-height: 50px;
    margin-left: 40px;
    align-items: center;
    .top-logo{
      height: 80%;
      width: auto;
    }
    :deep(.image-show) {
      .image-item{
        border: none;
        vertical-align: text-bottom;
      }
    }

    .top-name {
      font-size: 18px;
      font-weight: 600;
    }

    .my-name {
      margin-left: 30px;
      font-size: 12px;
      margin-top: 2px;
    }
  }

  .right {
    position: relative;
    display: inline-flex;
    line-height: 50px;
    margin-right: 20px;
    align-items: center;

    .setting-icon {
      line-height: 50px;
      color: var(--desc-font-color);
    }

    .item {
      margin-right: 10px;

      &.avatar {
        color: #FFF;
        width: 28px;
        height: 28px;
        background: var(--desc-font-color);
        text-align: center;
        border-radius: 28px;
        display: block;
        line-height: 28px;
        font-size: 18px;
      }
    }

    .item:last-child {
      margin-right: 0;
    }

    .notice-list {
      .notice-wrapper {
        color: red;
      }
    }

    .role-name {
      color: var(--desc-font-color);
      font-size: 12px;
    }

    .tips-message {
      position: relative;
      font-size: 16px;
      margin-right: 20px;

      .message-count {
        position: absolute;
        top: 10px;
        right: -50%;
        font-size: 9px;
        background: var(--el-color-danger);
        height: 10px;
        line-height: 10px;
        padding: 2px;
        border-radius: 10px;
        color: #FFF;
      }
    }
  }

  .message-list {
    position: absolute;
    right: 20px;
    top: 55px;
    width: 380px;
    max-height: 520px;
    background: #FFF;
    border: none;
    z-index: 9999;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 0 1px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    overflow: hidden;
    animation: slideDown 0.3s ease-out;

    .message-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 20px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: #fff;

      .message-left {
        display: flex;
        gap: 8px;

        :deep(.table-button) {
          background: rgba(255, 255, 255, 0.2);
          color: #fff;
          border: 1px solid rgba(255, 255, 255, 0.3);
          padding: 6px 12px;
          font-size: 13px;
          border-radius: 6px;
          transition: all 0.3s;

          &:hover {
            background: rgba(255, 255, 255, 0.3);
            border-color: rgba(255, 255, 255, 0.5);
          }

          &:disabled,
          &.is-disabled {
            background: rgba(255, 255, 255, 0.9);
            color: #667eea;
            border-color: transparent;
            font-weight: 500;
          }
        }
      }

      .message-right {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 10px;

        :deep(.el-checkbox) {
          height: auto;

          .el-checkbox__inner {
            background: rgba(255, 255, 255, 0.2);
            border-color: rgba(255, 255, 255, 0.5);
          }

          .el-checkbox__label {
            color: #fff;
          }
        }

        :deep(.table-button) {
          background: rgba(255, 255, 255, 0.2);
          color: #fff;
          border: 1px solid rgba(255, 255, 255, 0.3);
          padding: 6px 14px;
          font-size: 13px;
          border-radius: 6px;
          transition: all 0.3s;

          &:hover {
            background: rgba(255, 255, 255, 0.3);
            transform: translateY(-1px);
          }
        }
      }
    }

    .message-list-info {
      overflow-y: auto;
      overflow-x: hidden;
      flex: 1;
      padding: 12px;
      background: #fafbfc;

      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background: #dcdfe6;
        border-radius: 3px;

        &:hover {
          background: #c0c4cc;
        }
      }

      .message-empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 260px;
        color: #999;

        .empty-icon {
          font-size: 56px;
          margin-bottom: 16px;
          opacity: 0.6;
        }

        .empty-text {
          font-size: 14px;
          color: #909399;
        }
      }

      .message-item {
        padding: 14px 16px;
        margin-bottom: 10px;
        background: #fff;
        border: none;
        border-radius: 10px;
        display: flex;
        align-items: flex-start;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

        &:first-child {
          margin-top: 0;
        }

        &:last-child {
          margin-bottom: 0;
        }

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
          border: none;
        }

        .message-status {
          margin-right: 8px;
          margin-top: 2px;
          display: flex;
          align-items: center;

          .status-badge {
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            flex-shrink: 0;
          }

          .unread-badge {
            background: var(--el-color-danger);
            box-shadow: 0 0 0 2px rgba(245, 108, 108, 0.2);
            animation: pulse-unread 2s ease-in-out infinite;
          }

          .read-badge {
            background: #e4e7ed;
            border: 1px solid #dcdfe6;
          }
        }

        .message-check {
          margin-right: 10px;
          margin-top: 2px;
        }

        .message-detail {
          flex: 1;
          overflow: hidden;

          .detail-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 6px;
            gap: 8px;

            .detail-title {
              flex: 1;
              min-width: 0;
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              gap: 6px;

              .message-type-tag {
                display: inline-block;
                padding: 3px 10px;
                font-size: 12px;
                border-radius: 12px;
                font-weight: 500;
                color: #fff;
                flex-shrink: 0;

                &.tag-notice {
                  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                }

                &.tag-warning {
                  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
                }
              }

              .message-level-tag {
                display: inline-block;
                padding: 3px 8px;
                font-size: 11px;
                border-radius: 10px;
                font-weight: 500;
                flex-shrink: 0;

                &.level-2 {
                  background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
                  color: #e67e22;
                  border: none;
                }

                &.level-3 {
                  background: linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%);
                  color: #e74c3c;
                  border: none;
                  font-weight: 600;
                  animation: shake 0.5s infinite;
                }
              }

              .title-text {
                font-size: 14px;
                font-weight: 500;
                flex: 1;
                min-width: 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .expand-icon {
                font-size: 14px;
                color: #999;
                margin-left: 4px;
                transition: transform 0.3s;
                flex-shrink: 0;
              }
            }

            .detail-time {
              font-size: 12px;
              color: #999;
              white-space: nowrap;
              flex-shrink: 0;
              min-width: fit-content;
            }
          }

          .detail-info {
            font-size: 12px;
            color: #666;
            line-height: 1.5;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            gap: 10px;

            .content-preview {
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }

            .view-detail-btn {
              color: #409eff;
              cursor: pointer;
              font-size: 12px;
              white-space: nowrap;
              flex-shrink: 0;
              transition: all 0.3s;

              &:hover {
                color: #66b1ff;
                text-decoration: underline;
              }
            }
          }

          .detail-content {
            margin-top: 10px;
            padding-top: 10px;
            border-top: 1px dashed var(--yq-border-color);

            .content-full-wrapper {
              position: relative;
              max-height: 200px;
              overflow: hidden;
              margin-bottom: 10px;

              // 只在有溢出时显示渐变遮罩
              &.has-overflow::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                height: 40px;
                background: linear-gradient(to bottom, transparent, #fff);
                pointer-events: none;
              }
            }

            .content-full {
              font-size: 13px;
              color: #333;
              line-height: 1.8;
              white-space: pre-wrap;
              word-break: break-word;

              // 富文本内容样式
              :deep(img) {
                max-width: 100%;
                height: auto;
                display: block;
                margin: 10px 0;
                border-radius: 4px;
              }

              :deep(p) {
                margin: 8px 0;
                line-height: 1.8;
              }

              :deep(a) {
                color: #409eff;
                text-decoration: none;

                &:hover {
                  text-decoration: underline;
                }
              }

              :deep(ul), :deep(ol) {
                padding-left: 20px;
                margin: 8px 0;
              }

              :deep(li) {
                margin: 4px 0;
              }

              :deep(strong) {
                font-weight: 600;
              }

              :deep(h1), :deep(h2), :deep(h3), :deep(h4), :deep(h5), :deep(h6) {
                margin: 12px 0 8px;
                font-weight: 600;
              }
            }

            .content-meta {
              display: flex;
              gap: 20px;
              font-size: 12px;
              color: #999;
              padding-top: 8px;
              border-top: 1px solid #f0f0f0;

              span {
                display: flex;
                align-items: center;
              }
            }

            .detail-actions {
              margin-top: 12px;
              padding-top: 12px;
              border-top: 1px solid #f0f0f0;
              text-align: center;

              .view-detail-btn {
                color: #409eff;
                cursor: pointer;
                font-size: 13px;
                transition: all 0.3s;
                display: inline-block;

                &:hover {
                  color: #66b1ff;
                  text-decoration: underline;
                }
              }
            }
          }
        }

        &.expanded {
          .message-detail {
            .detail-header .detail-title .expand-icon {
              transform: rotate(180deg);
            }
          }
        }

        &.read {
          background: #f8f9fa;
          opacity: 0.85;

          .message-detail {
            .detail-header .detail-title .title-text {
              color: #909399;
            }

            .detail-info {
              color: #a8abb2;
            }

            .detail-content .content-full-wrapper.has-overflow::after {
              background: linear-gradient(to bottom, transparent, #f8f9fa);
            }
          }

          &:hover {
            opacity: 1;
          }
        }
      }

      .message-loading {
        text-align: center;
        padding: 15px;
        color: #999;
        font-size: 14px;
      }

      .message-no-more {
        text-align: center;
        padding: 15px;
        color: #999;
        font-size: 12px;
      }
    }
  }
}

// 未读标记脉动动画
@keyframes pulse-unread {
  0% {
    box-shadow: 0 0 0 0 rgba(245, 108, 108, 0.4);
  }
  50% {
    box-shadow: 0 0 0 4px rgba(245, 108, 108, 0.1);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(245, 108, 108, 0);
  }
}

// 消息列表下滑动画
@keyframes slideDown {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

// 紧急标签抖动动画
@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-2px);
  }
  75% {
    transform: translateX(2px);
  }
}

// 消息详情弹窗样式
:deep(.message-detail-dialog) {
  .el-dialog__header {
    padding: 10px 24px;
    border-bottom: 1px solid var(--yq-border-color);

    .el-dialog__title {
      font-size: 18px;
      font-weight: 600;
      color: #303133;
    }

    .el-dialog__headerbtn {
      top: 20px;

      .el-dialog__close {
        font-size: 20px;
        color: #909399;

        &:hover {
          color: #409eff;
        }
      }
    }
  }

  .el-dialog__body {
    padding: 24px;
    max-height: 70vh;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f5f5f5;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: #dcdfe6;
      border-radius: 3px;

      &:hover {
        background: #c0c4cc;
      }
    }
  }

  .el-dialog__footer {
    padding: 16px 24px;
    border-top: 1px solid var(--yq-border-color);

    .dialog-footer {
      text-align: center;
    }
  }
}

.message-detail-wrapper {
  .detail-header-info {
    display: flex;
    gap: 8px;
    margin-bottom: 16px;

    .message-type-tag {
      display: inline-block;
      padding: 4px 12px;
      font-size: 13px;
      border-radius: 12px;
      font-weight: 500;
      color: #fff;

      &.tag-notice {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      }

      &.tag-warning {
        background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
      }
    }

    .message-level-tag {
      display: inline-block;
      padding: 4px 10px;
      font-size: 12px;
      border-radius: 10px;
      font-weight: 500;

      &.level-2 {
        background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
        color: #e67e22;
      }

      &.level-3 {
        background: linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%);
        color: #e74c3c;
        font-weight: 600;
      }
    }
  }

  .detail-meta-info {
    display: flex;
    gap: 24px;
    margin-bottom: 20px;
    padding: 12px 16px;
    background: #f8f9fa;
    border-radius: 8px;

    .meta-item {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 13px;
      color: #606266;

      .yq-icon {
        font-size: 14px;
        color: #909399;
      }
    }
  }

  .detail-content-wrapper {
    .rich-content {
      font-size: 14px;
      color: #333;
      line-height: 1.8;

      :deep(img) {
        max-width: 100%;
        height: auto;
        display: block;
        margin: 16px 0;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }

      :deep(video){
        width: 100%;
      }

      :deep(p) {
        margin: 12px 0;
        line-height: 1.8;
      }

      :deep(a) {
        color: #409eff;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }

      :deep(ul), :deep(ol) {
        padding-left: 24px;
        margin: 12px 0;
      }

      :deep(li) {
        margin: 6px 0;
      }

      :deep(strong) {
        font-weight: 600;
        color: #303133;
      }

      :deep(h1), :deep(h2), :deep(h3), :deep(h4), :deep(h5), :deep(h6) {
        margin: 16px 0 12px;
        font-weight: 600;
        color: #303133;
      }

      :deep(h1) {
        font-size: 24px;
      }

      :deep(h2) {
        font-size: 20px;
      }

      :deep(h3) {
        font-size: 18px;
      }

      :deep(blockquote) {
        margin: 12px 0;
        padding: 12px 16px;
        background: #f5f7fa;
        border-left: 4px solid #409eff;
        color: #606266;
      }

      :deep(code) {
        padding: 2px 6px;
        background: #f5f7fa;
        border-radius: 4px;
        font-family: 'Courier New', monospace;
        font-size: 13px;
        color: #e96900;
      }

      :deep(pre) {
        margin: 12px 0;
        padding: 12px;
        background: #f5f7fa;
        border-radius: 6px;
        overflow-x: auto;

        code {
          padding: 0;
          background: transparent;
        }
      }

      :deep(table) {
        width: 100%;
        border-collapse: collapse;
        margin: 12px 0;

        th, td {
          border: 1px solid #dcdfe6;
          padding: 8px 12px;
          text-align: left;
        }

        th {
          background: #f5f7fa;
          font-weight: 600;
        }

        tr:nth-child(even) {
          background: #fafafa;
        }
      }
    }

    .plain-content {
      font-size: 14px;
      color: #333;
      line-height: 1.8;
      white-space: pre-wrap;
      word-break: break-word;
    }
  }
}
</style>